import axios, {
	AxiosError,
	AxiosHeaders,
	InternalAxiosRequestConfig,
} from "axios";
import { DEFAULT_ERROR } from "./contants";
import { getOktaToken } from "./getOktaToken";
import { AppStore, store } from "../../store";
import { setError } from "../../features/error_modal/ErrorModal.slice";

export const axiosInstance = axios.create({
	baseURL: import.meta.env.VITE_APP_API_PATH
});


export const requestInterceptor = 
	(config: InternalAxiosRequestConfig, gepoStore: AppStore) => {
		return getOktaToken().then((token) => {
			(config.headers as AxiosHeaders).set(
				"Authorization",
				"Bearer " + token
			);

			const locale = gepoStore.getState().i18n.locale;
			if (config.params instanceof URLSearchParams) {
				config.params.set("locale", locale);
			} else {
				config.params = { ...(config.params ?? {}), locale };
			}

			return Promise.resolve(config);
		});
	}

axiosInstance.interceptors.request.use(
	(config: InternalAxiosRequestConfig) => {
		return requestInterceptor(config, store);
	},
	(err) => {
		return Promise.reject(err);
	}
);

export const responseErrorInterceptor =
	(gepoStore: AppStore) => (error: AxiosError<any>) => {
		if (
			error.response &&
			DEFAULT_ERROR.codes.includes(error.response.status)
		) {
			const message =
				error?.response?.data?.reason || DEFAULT_ERROR.message;
			gepoStore.dispatch(setError({ error: message }));
		}
		return Promise.reject(error);
	};

axiosInstance.interceptors.response.use(
	(response) => response,
	responseErrorInterceptor(store)
);

export const apiPost = (
	url: string,
	data: any,
	config?: Partial<InternalAxiosRequestConfig>
) => {
	return axiosInstance.post(url, data, config);
};

export const apiDelete = (
	url: string,
	config?: Partial<InternalAxiosRequestConfig>
) => {
	return axiosInstance.delete(url, config);
};

export const apiPut = (
	url: string,
	data: any,
	config?: Partial<InternalAxiosRequestConfig>
) => {
	return axiosInstance.put(url, data, config);
};

export const apiGet = (
	url: string,
	config?: Partial<InternalAxiosRequestConfig>
) => {
	return axiosInstance.get(url, config);
};

export const apiPatch = (
	url: string,
	data: any,
	config?: Partial<InternalAxiosRequestConfig>
) => {
	return axiosInstance.patch(url, data, config);
};
